module.exports = __webpack_public_path__ + "static/img/tgl-loding.d266e618.gif";